import type {MessageDescriptor} from 'react-intl';

type FormatMessage = (
    messageDescriptor: MessageDescriptor,
    values?: Record<string, any>
) => string;

export const getBedroomValue = (
    bedroomsCount: number,
    formatMessage: FormatMessage
) => {
    const rangeMessageDescriptor = {
        id: 'bedroomsValueLabel',
        defaultMessage:
            '{bedroomsCount, plural, =0 {Any} other {{bedroomsCount}+}}',
        description: 'Specifies any bedroom count to filter on',
    };
    return formatMessage(rangeMessageDescriptor, {bedroomsCount});
};

export const getBathroomValue = (
    bathroomsCount: number,
    formatMessage: FormatMessage
) => {
    const rangeMessageDescriptor = {
        id: 'bathroomsValueLabel',
        defaultMessage:
            '{bathroomsCount, plural, =0 {Any} other {{bathroomsCount}+}}',
        description: 'Specifies any bathroom count to filter on',
    };
    return formatMessage(rangeMessageDescriptor, {bathroomsCount});
};

export const getBedroomLabel = (formatMessage: FormatMessage) => {
    return formatMessage({
        id: 'bedroomsLabel',
        defaultMessage: 'Bedrooms',
        description: 'Label for the amount of bedrooms to filter on',
    });
};

export const getBathroomLabel = (formatMessage: FormatMessage) => {
    return formatMessage({
        id: 'bathroomsLabel',
        defaultMessage: 'Bathrooms',
        description: 'Label for the amount of bedrooms to filter on',
    });
};

/* eslint-disable complexity */
export const getRoomsAndSpacesLabel = (
    appliedMinBedrooms: number | null,
    appliedMinBathrooms: number | null,
    formatMessage: FormatMessage
) => {
    let bedroomsLabel;
    let bathroomsLabel;

    if (appliedMinBedrooms) {
        bedroomsLabel = `${appliedMinBedrooms}+ ${getBedroomLabel(
            formatMessage
        )}`;
    }

    if (appliedMinBathrooms) {
        bathroomsLabel = `${appliedMinBathrooms}+ ${getBathroomLabel(
            formatMessage
        )}`;
    }

    /* istanbul ignore else */
    if (bedroomsLabel && bathroomsLabel) {
        return `${bedroomsLabel}, ${bathroomsLabel}`;
    } else if (bedroomsLabel) {
        return bedroomsLabel;
    } else if (bathroomsLabel) {
        return bathroomsLabel;
    }

    return null;
};
/* eslint-enable complexity */
